import { useAuth } from "../context/AuthContext";

export default function Overview() {
  const { user, organization } = useAuth();

  return (
    <div>
      <h1>Welcome, {user?.firstName}</h1>
      <p className="page-subtitle">
        Here's what's happening with {organization?.name}
      </p>

      <div className="tools-grid">
        <div className="tool-card">
          <div className="tool-icon">📈</div>
          <h3>Quick Stats</h3>
          <p>Organization plan: <strong>{organization?.plan}</strong></p>
          <p>Role: <strong>{user?.role}</strong></p>
        </div>

        <div className="tool-card">
          <div className="tool-icon">🚀</div>
          <h3>Getting Started</h3>
          <p>Explore available tools and invite your team members to get the most out of your Business System.</p>
        </div>
      </div>
    </div>
  );
}
